<template>
  <div>
    <Header title="CIAM登录" />
    <van-loading type="spinner" class="loading" size="35px" color="#117281" v-show="loading"></van-loading>
    <div v-if="clientList.length!==0">
      <div class="selectClient">
        <div class="title">该手机号对应多个extra账号，请选择要绑定的账号。</div>
        <div class="select-item">
          <van-radio-group v-model="clientId">
            <van-radio class="item-info" v-for="item of clientList" :name="item.clientId" :key="item.clientId">{{item.clientCode}}&nbsp;&nbsp;&nbsp;{{item.clientName}}&nbsp;&nbsp;&nbsp;{{item.contactPerson}}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="footer">
        <div class="btn submit-btn color-white" @click="gotoWeb()">取消</div>
        <div class="btn submit-btn" @click="selectClient()">确定</div>
      </div>
    </div>
    <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
  </div>
</template>

<script>
import Header from '@/components/header'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
import { userUtils } from '../../utils/auth'
import ssoLoginApi from '@/api/sso-login'

export default {
  components: {
    Header,
    ReturnToLogin
  },
  data () {
    return {
      clientId: '',
      loading: false,
      clientList: [
        // {
        //   'clientCode': 'extra21000934',
        //   'clientId': '1716421',
        //   'clientName': '上海一号修理厂',
        //   'contactPerson': '张三'
        // }
      ]
    }
  },
  created () {
    this.auth()
  },
  methods: {
    auth (clientId) {
      this.loading = true
      const code = this.$route.query.code || ''
      const loginParam = {
        code: code,
        origin: 'extra-app',
        clientId: clientId
      }
      ssoLoginApi
        .ssoLogin(loginParam)
        .then(res => {
          this.loading = false
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            userUtils.setUserLocal(res.data.resultData)
            localStorage.setItem('ssoToken', res.data.resultData.userSsoToken.idToken)
            if (res.data.resultData.activityCoinDTO) {
              // 回归活动
              this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
            } else {
              this.handleJumpHome(res)
            }
          } else if (res.data.resultCode === '02') {
            localStorage.setItem('ssoToken', res.data.resultData.userSsoToken.idToken)
            this.$dialog.confirm({
              title: '提示',
              message: '该手机号未注册易加账号，是否注册账号？',
              confirmButtonText: '前往注册',
              cancelButtonText: '退出登录'
            }).then(() => {
              document.location = process.env.VUE_APP_EXTRA_SITE + '/v2/login2'
            }).catch(() => {
              this.$router.push({ name: 'ciamLogout', query: { type: '02' } })
            })
          } else if (res.data.resultCode === '03') {
            if (res.data.resultData.clientList) {
              this.clientList = res.data.resultData.clientList
              this.$dialog.alert({
                title: '账号绑定',
                message: '该手机号对应多个extra账号，请选择要绑定的账号。'
              }).then(() => {
              })
            } else {
              this.$message({
                message: '登录失败',
                type: 'error'
              })
              document.location = process.env.VUE_APP_EXTRA_SITE + '/v2/home-main'
            }
          } else {
            this.$notify({
              background: '#1989fa',
              message: res.data.resultMsg,
              className: 'notify-error-msg'
            })
            document.location = process.env.VUE_APP_EXTRA_SITE + '/v2/home-main'
          }
        })
        .catch(() => {
          this.loading = true
          this.$toast.clear()
        })
    },
    handleJumpHome () {
      let state = (this.$route.query.state === 'undefined' ? '/v2/home-main' : this.$route.query.state)
      state = decodeURIComponent(state)
      document.location = process.env.VUE_APP_EXTRA_SITE + state
    },
    gotoWeb () {
      document.location = process.env.VUE_APP_EXTRA_SITE + '/v2/home-main'
    },
    selectClient () {
      if (!this.clientId) {
        this.$toast('请选择要绑定的账号')
        return
      }
      this.auth(this.clientId)
    }
  }
}
</script>

<style scoped>
.selectClient{
  position: relative;
  top: 56px;
  margin: 0px 8px 0 8px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
}
.title{
  margin-top: 10px;
  line-height: 25px;
  font-weight: 600;
}
.item-info{
  margin: 10px 5px;
}
.btn{
  width: 100%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}
.submit-btn{
  margin: 10px;
  padding: 12px;
}
.footer{
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-evenly;
}
.color-white{
  background-color: rgb(255, 255, 255);
  color: black;
  border: solid 1px rgb(214, 214, 214);
}
.block{
  width: 100vw;
  height: 130px;
}
.loading{
  position: absolute;
  top: 40%;
  left: calc(50vw - 17.5px);
}
</style>
